import ViewAllStdTechnicalData from "./ViewAllStdTechnicalData";

export default ViewAllStdTechnicalData;
